// Versione "lite" del TodayWidget per la home di gojjobet (logica jamibet/awrabet, colori gojjo-lite).
import { h, Component } from 'preact';
import PFeed from '../../../services/prematch-feed';
import { RegionFlagIcon } from '../../jamibet/desktop-templates/prematch-menu.jsx';

import { CardHeaderTitle } from './templates-card-header.jsx';
import { MobileEvent } from './mobile-event.jsx';

import { TodayWidget as AwrabetTodayWidget, DailyEventDisplay as AwrabetDailyEventDisplay } from '../../awrabet/mobile-components/today-widget.jsx';

export class TodayWidget extends AwrabetTodayWidget {
    state = {
        tournaments: [],
        currentPage: 1,
        visibleCount: 5,
    };
    componentDidUpdate(prevProps) {
        if (this.props.sport?.id !== prevProps.sport?.id) {
            this.fetchTournaments();
        }
    }

    fetchTournaments() {
        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime();

        PFeed.getMenu((label, menu) => {
            let tournaments = [];

            if (this.props.sport && this.props.sport.id) {
                const sportData = menu[this.props.sport.id];
                if (sportData && sportData.sub) {
                    Object.values(sportData.sub).forEach(category => {
                        Object.values(category.sub).forEach(tournament => {
                            if (tournament['next-event'] <= endOfDay) {
                                tournaments.push({
                                    ...tournament,
                                    categoryOrder: category.order,
                                    tournamentOrder: tournament.order
                                });
                            }
                        });
                    });
                }
            } else {
                Object.values(menu).forEach(sport => {
                    if (sport.sub) {
                        Object.values(sport.sub).forEach(category => {
                            Object.values(category.sub).forEach(tournament => {
                                if (tournament['next-event'] <= endOfDay) {
                                    tournaments.push({
                                        ...tournament,
                                        categoryOrder: category.order,
                                        tournamentOrder: tournament.order
                                    });
                                }
                            });
                        });
                    }
                });
            }

            tournaments = tournaments.sort((a, b) => a.categoryOrder == 0 ? b.categoryOrder : a.categoryOrder - b.categoryOrder)
                .sort((a, b) => a.tournamentOrder == 0 ? b.tournamentOrder : a.tournamentOrder - b.tournamentOrder);

            const topLeagues = tournaments.filter(tournament => PFeed.mainTournaments.includes(tournament.id));
            const otherTournaments = tournaments.filter(tournament => !PFeed.mainTournaments.includes(tournament.id));

            this.setState({ tournaments: [...topLeagues, ...otherTournaments] });
        });
    }

    showMore = () => {
        this.setState({ visibleCount: this.state.visibleCount + 5 });
    };

    render({ sport, showPagination = true }) {
        const { tournaments, currentPage, visibleCount } = this.state;

        if (showPagination) {
            const displayedTournaments = tournaments.slice(0, visibleCount);
            const hasMore = visibleCount < tournaments.length;

            return (
                <div>
                    <div class="bg-gojjo-lite-100">
                        {displayedTournaments.map(tournament => (
                            <TournamentDisplay tournament={tournament} key={tournament.id} />
                        ))}
                    </div>
                    {hasMore && (
                        <div class="p-4 text-center">
                            <button
                                onClick={this.showMore}
                                class="bg-gojjo-gold-lite-500 text-gojjo-lite-950 px-6 py-2 rounded uppercase"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
            );
        } else {
            return (
                <div>
                    <div class="bg-gojjo-lite-100">
                        {tournaments.map(tournament => (
                            <TournamentDisplay tournament={tournament} key={tournament.id} />
                        ))}
                    </div>
                </div>
            );
        }
    }
}

class TournamentDisplay extends Component {
    render() {
        const { tournament } = this.props;
        return (
            <div class="pb-0.5 bg-gojjo-lite-200 text-gojjo-lite-950 ">
                <div class="flex items-center py-1 gap-1">
                    <div class="pl-2">
                        <div class="h-4 w-6 flex items-center justify-center">
                            <RegionFlagIcon
                                category={PFeed.getWithParents(tournament.parent).category}
                            />
                        </div>
                    </div>
                    <CardHeaderTitle>{PFeed.getWithParents(tournament.parent).category.name} - {tournament.name}</CardHeaderTitle>
                </div>
                <DailyEventDisplay tournament={tournament} />
            </div>
        );
    }
}

export class DailyEventDisplay extends AwrabetDailyEventDisplay {
    render() {
        const { tournamentData } = this.state;
        if (!tournamentData) return <div></div>;

        const today = new Date();
        const endOfDay = new Date(today.setHours(23, 59, 59, 999)).getTime() / 1000;
        const eventsToday = Object.values(tournamentData.sub).filter(event => event.date <= endOfDay);

        const { sport, category, tournament } = PFeed.getWithParents(this.props.tournament.id);
        const displayRuleFiltered = this.displayRuleOnlyOneMarket(tournamentData.displayRule);

        return (
            <div>
                {eventsToday.map(event => (
                    <MobileEvent
                        tournament={tournament}
                        event={event}
                        displayRuleFiltered={displayRuleFiltered}
                    />
                ))}
            </div>
        );
    }
}
